module.exports = __webpack_public_path__ + "static/state-farm-06c9639f16a2ecbef71ac33399dd3901.jpg";